import { createApp } from "vue";
import App from "./App.vue";
import Router from "./router";
import * as utils from "commons-utils";
import ErrorMessages from "../../../../../../WebApp/Commons/ErrorMessages.json";
import axios from "axios";
const app = createApp(App);

// すべてのVueでErrorMessages.jsonを参照できるようにする
app.config.globalProperties.$errorMessages = ErrorMessages;

app.config.globalProperties.$utils = utils;

app.config.globalProperties.$defaultErrorCallback = function (err) {
    const errData = err.response && err.response.data;
    let msg = errData.reload ? ErrorMessages.UnspecifiedExceptionWithReload : ErrorMessages.UnspecifiedException;
    if (errData) {
        if (errData.errorType === "App") {
            if (ErrorMessages[errData.msgCode]) {
                msg = ErrorMessages[errData.msgCode];
                for (const [key, value] of Object.entries(errData.msgParams || {})) {
                    const target = "${" + key + "}";
                    msg = msg.replace(target, value);
                }
            }
        }
    }

    // 呼び出し元がApp.vueかどうかでメソッドの呼び出し方が変わる
    if (this.openAlertModal) {
        // App.vueから呼び出されている場合
        this.openAlertModal(msg, () => {
            if (errData.reload) {
                location.reload();
            } else {
                this.hideSpinner();
            }
        });
    } else {
        // App.vue以外から呼び出されている場合
        this.$emit("openAlertModal", msg, () => {
            if (errData.reload) {
                location.reload();
            } else {
                this.$emit("hideSpinner");
            }
        });
    }
};

/***
 * ログインまたはサインアップのリクエストを行う
 * @param {string} path (login|signup)
 * @param {any} body BODY
 * @param {function} thenCallback 成功時のコールバック処理
 * @param {function} catchCallback 失敗時のコールバック処理
 */
app.config.globalProperties.$authRequest = function (path, body, thenCallback, catchCallback) {
    if (!body) {
        body = {};
    }
    const url = "/mamolico/nc-s02d02jp-store/" + path;
    axios
        .post(url, body)
        .then((res) => {
            thenCallback(res);
        })
        .catch((err) => {
            if (catchCallback) {
                catchCallback(err);
            } else {
                this.$defaultErrorCallback(err);
            }
        });
};

app.config.globalProperties.$axios = function (method, path, body, thenCallback, catchCallback) {
    const token = document.token;

    // ToDo:: IDトークンがない場合はどうするのがよいか
    if (!token) {
        const err = {
            response: {
                data: {
                    msgCode: "UnauthorizedException"
                }
            }
        };
        if (catchCallback) {
            catchCallback(err);
        } else {
            this.$defaultErrorCallback(err);
        }
        return;
    }

    if (!body) {
        body = {};
    }
    const url = "/mamolico/nc-s02d02jp-store/" + encodeURIComponent(path);
    const options = {
        headers: {
            Authorization: token
        }
    };
    // リクエスト処理
    let axiosMethod;
    if (method.toUpperCase() === "GET") {
        axiosMethod = axios({
            url: url,
            method: "GET",
            params: body,
            headers: options.headers
        });
    } else if (method.toUpperCase() === "POST") {
        axiosMethod = axios.post(url, body, options);
    } else if (method.toUpperCase() === "PUT") {
        axiosMethod = axios.put(url, body, options);
    } else if (method.toUpperCase() === "DELETE") {
        axiosMethod = axios({
            url: url,
            method: "DELETE",
            params: body,
            headers: options.headers
        });
    }
    axiosMethod
        .then((res) => {
            thenCallback(res);
        })
        .catch((err) => {
            if (catchCallback) {
                catchCallback(err);
            } else {
                this.$defaultErrorCallback(err);
            }
        });
};

app.use(Router);
app.mount("#app");
